<div class="modal-header">
  <h4 class="modal-title pull-left">Cambiar contraseña</h4>
  <button
    name="modalPasswordRef"
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="modalPasswordRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="formPassword">
    <div class="row">
      <div class="mb-3 col-md-6">
        <label>Contraseña Actual (*)</label>
        <div class="input-group">
          <input
            [type]="estadoInput[0].tipo"
            class="form-control"
            formControlName="pwd"
          />
          <span class="input-group-text">
            <button>
              <i
                [class]="estadoInput[0].icono"
                (click)="cambiarEstado(estadoInput[0])"
              ></i>
            </button>
          </span>
        </div>
        <p
          *ngIf="
            formPassword.controls['pwd'].invalid &&
            formPassword.controls['pwd'].touched
          "
          class="text-error-form-2"
        >
          La contraseña no puede tener menos de 6 caracteres
        </p>
      </div>
      <div class="mb-3 col-md-6"></div>
      <div class="mb-3 col-md-6">
        <label>Contraseña Nueva (*)</label>
        <div class="input-group">
          <input
            [type]="estadoInput[1].tipo"
            class="form-control"
            formControlName="password"
          />
          <span class="input-group-text">
            <button>
              <i
                [class]="estadoInput[1].icono"
                (click)="cambiarEstado(estadoInput[1])"
              ></i>
            </button>
          </span>
        </div>
        <p
          *ngIf="
            formPassword.controls['password'].invalid &&
            formPassword.controls['password'].touched
          "
          class="text-error-form-2"
        >
          La contraseña no puede tener menos de 6 caracteres
        </p>
      </div>
      <div class="mb-3 col-md-6">
        <label>Repite nueva contraseña (*)</label>
        <div class="input-group">
          <input
            [type]="estadoInput[2].tipo"
            class="form-control"
            formControlName="confirmPassword"
          />
          <span class="input-group-text">
            <button>
              <i
                [class]="estadoInput[2].icono"
                (click)="cambiarEstado(estadoInput[2])"
              ></i>
            </button>
          </span>
        </div>
        <p
          class="text-error-form-2"
          *ngIf="formPassword.errors?.['doesMatchPassword']"
        >
          Las contraseñas no son iguales, por favor intente nuevamente.
        </p>

        <p
          class="text-error-form-2"
          *ngIf="formPassword.controls['confirmPassword'].errors?.['required'] && formPassword.controls['confirmPassword'].touched"
        >
          El campo confirme contraseña es requerido
        </p>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    name="cerrar"
    class="btn btn-danger"
    (click)="modalPasswordRef.hide()"
  >
    Cancelar
  </button>
  <button
    name="agregarDireccion"
    class="btn btn-secondary"
    (click)="cambiarPassword()"
    [disabled]="!formPassword.valid"
  >
    Actualizar
  </button>
</div>
